export const svgZoom = (
  <>
    <rect x="1" y="1" width="18" height="18" rx="4" fill="#2D8CFF" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 7H5v4a2 2 0 0 0 2 2h5V9a2 2 0 0 0-2-2zm5 0v6l-2-1.5v-3L15 7z"
      fill="#fff"
    />
  </>
);

export const svgGlobe = (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.833984 9.99998C0.833984 4.93737 4.93804 0.833313 10.0007 0.833313C15.0633 0.833313 19.1673 4.93737 19.1673 9.99998C19.1673 15.0626 15.0633 19.1666 10.0007 19.1666C4.93804 19.1666 0.833984 15.0626 0.833984 9.99998ZM10.0007 2.49998C5.85851 2.49998 2.50065 5.85784 2.50065 9.99998C2.50065 14.1421 5.85851 17.5 10.0007 17.5C14.1428 17.5 17.5006 14.1421 17.5006 9.99998C17.5006 5.85784 14.1428 2.49998 10.0007 2.49998Z"
      fill="#D3D2D4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.833984 10C0.833984 9.53978 1.20708 9.16669 1.66732 9.16669H18.334C18.7942 9.16669 19.1673 9.53978 19.1673 10C19.1673 10.4603 18.7942 10.8334 18.334 10.8334H1.66732C1.20708 10.8334 0.833984 10.4603 0.833984 10Z"
      fill="#D3D2D4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.3021 0.889768C10.4262 0.937911 10.5339 1.01364 10.6193 1.10834C12.8378 3.53895 14.0986 6.69239 14.1671 9.98266C14.1674 9.99423 14.1674 10.0058 14.1671 10.0174C14.0986 13.3093 12.8366 16.4643 10.6159 18.8954C10.4581 19.0682 10.2348 19.1667 10.0007 19.1667C9.76655 19.1667 9.54325 19.0682 9.38536 18.8954C7.16473 16.4643 5.90275 13.3093 5.83417 10.0174C5.83392 10.0058 5.83392 9.99423 5.83417 9.98266C5.90275 6.69073 7.16473 3.53577 9.38536 1.10466C9.61731 0.850728 9.98143 0.765371 10.3021 0.889768ZM7.50084 10C7.55796 12.5624 8.4392 15.0293 10.0006 17.041C11.5621 15.0293 12.4433 12.5624 12.5005 10C12.4433 7.43765 11.5621 4.97072 10.0007 2.95901C8.4392 4.97072 7.55796 7.43765 7.50084 10Z"
      fill="#D3D2D4"
    />
  </>
);

export const svgTRM = (
  <>
    <path d="M39.5521 9.0442H44.9849V27.1795H50.2004V9.0442H55.6332V4.47412H39.5521V9.0442ZM57.4441 4.54666V27.252H62.6596V18.2569L69.6135 27.1795H76.2053L68.3821 17.8217C71.2071 16.9512 73.0905 14.6299 73.0905 11.2204C73.0905 6.79543 69.9033 4.47412 65.6295 4.47412H57.4441V4.54666ZM62.6596 14.5573V8.60896H63.2391C65.1949 8.60896 67.5853 8.75404 67.5853 11.5831C67.5853 14.4122 65.2673 14.5573 63.2391 14.5573H62.6596ZM96.1979 27.1795H101.413L99.3852 4.47412H93.8799L88.8093 17.5315L83.7388 4.47412H78.2335L76.0604 27.1795H81.2759L82.3624 13.7594H82.5073L87.2157 27.1069H90.2581L94.9665 13.7594H95.1114L96.1979 27.1795Z" />
    <path d="M18.5439 29.1615C18.5439 27.8557 17.6022 26.7676 16.3708 26.55V19.5135C17.0952 19.441 17.6747 19.1508 18.2541 18.7156L23.7594 24.2287C23.3247 24.9541 23.3972 25.9697 24.0491 26.55C24.7735 27.2754 26.0049 27.2754 26.7293 26.55C27.4537 25.8246 27.4537 24.5914 26.7293 23.866C26.0774 23.2131 25.1357 23.1406 24.4113 23.5758L18.9061 18.0627C19.3407 17.5549 19.6305 16.9021 19.7029 16.1766H26.7293C26.9466 17.4098 28.0332 18.3529 29.337 18.3529C30.7858 18.3529 31.9448 17.1922 31.9448 15.7414C31.9448 14.2906 30.6409 13.275 29.1921 13.275C27.8883 13.275 26.8017 14.218 26.5844 15.4512H19.558C19.4856 14.7258 19.1958 14.073 18.7612 13.5652L24.2664 8.05205C24.9908 8.4873 26.0049 8.41476 26.5844 7.76189C27.3088 7.03648 27.3088 5.80328 26.5844 5.07787C25.86 4.35246 24.6286 4.35246 23.9042 5.07787C23.2523 5.73074 23.1799 6.67377 23.6145 7.39918L18.2541 12.9848C17.7471 12.5496 17.0952 12.2594 16.3708 12.1869V5.22295C17.6022 5.00533 18.5439 3.91721 18.5439 2.61148C18.5439 1.16066 17.3849 0 15.9362 0C14.4874 0 13.3284 1.16066 13.3284 2.61148C13.3284 3.91721 14.2701 5.00533 15.5015 5.22295V12.1869C14.7772 12.2594 14.1252 12.5496 13.6182 12.9848L8.18539 7.54426C8.62001 6.81885 8.54758 5.80328 7.89564 5.22295C7.17127 4.49754 5.93984 4.49754 5.21547 5.22295C4.4911 5.94836 4.4911 7.18156 5.21547 7.90697C5.8674 8.55984 6.80909 8.63238 7.53346 8.19713L12.9662 13.6377C12.5316 14.1455 12.2419 14.7984 12.1694 15.5238H5.21547C4.99816 14.2906 3.9116 13.3475 2.60774 13.3475C1.15899 13.3475 0 14.5082 0 15.959C0 17.4098 1.15899 18.5705 2.60774 18.5705C3.9116 18.5705 4.99816 17.6275 5.21547 16.3943H12.1694C12.2419 17.1197 12.5316 17.7725 12.9662 18.2803L7.53346 23.7209C6.80909 23.2857 5.79497 23.3582 5.21547 24.0111C4.4911 24.7365 4.4911 25.9697 5.21547 26.6951C5.93984 27.4205 7.17127 27.4205 7.89564 26.6951C8.54758 26.0422 8.62001 25.0992 8.18539 24.3738L13.6906 18.8607C14.1977 19.2959 14.8496 19.5861 15.574 19.6586V26.6951C14.3425 26.9127 13.4009 28.0008 13.4009 29.3066C13.4009 30.7574 14.5599 31.918 16.0086 31.918C17.3849 31.8455 18.5439 30.6123 18.5439 29.1615Z" />
  </>
);

export const svgTwitter = (
  <>
    <path d="M21.533 4.85784C21.5482 5.07103 21.5482 5.28427 21.5482 5.49745C21.5482 12 16.599 19.4924 7.5533 19.4924C4.76648 19.4924 2.17767 18.6852 0 17.2843C0.395953 17.3299 0.776625 17.3452 1.18781 17.3452C3.48727 17.3452 5.60405 16.5685 7.29441 15.2437C5.13197 15.198 3.31978 13.7817 2.69541 11.8325C3 11.8781 3.30455 11.9086 3.62437 11.9086C4.06598 11.9086 4.50764 11.8477 4.91878 11.7411C2.66498 11.2842 0.974578 9.30455 0.974578 6.91369V6.8528C1.62937 7.21828 2.39086 7.4467 3.19791 7.47712C1.87303 6.59386 1.00505 5.08627 1.00505 3.38067C1.00505 2.46698 1.24866 1.62942 1.67508 0.898453C4.09641 3.88322 7.73602 5.83242 11.8172 6.04566C11.7411 5.68017 11.6954 5.2995 11.6954 4.91878C11.6954 2.20809 13.8883 0 16.6141 0C18.0304 0 19.3095 0.593906 20.208 1.5533C21.3197 1.34011 22.3857 0.928922 23.3299 0.365484C22.9643 1.50764 22.1877 2.46703 21.1674 3.07613C22.1573 2.96958 23.1167 2.69541 23.9999 2.31473C23.33 3.28931 22.4924 4.1573 21.533 4.85784Z" />
  </>
);

export const svgPhone = (
  <>
    <rect x="1" y="1" width="18" height="18" rx="4" fill="#00B07B" />
    <path
      d="M15 12.487v1.505a1.002 1.002 0 0 1-1.096 1.004 9.963 9.963 0 0 1-4.34-1.54 9.795 9.795 0 0 1-3.016-3.011 9.918 9.918 0 0 1-1.544-4.351 1.002 1.002 0 0 1 1-1.094h1.509a1.007 1.007 0 0 1 1.006.863c.063.482.181.955.352 1.41a1.002 1.002 0 0 1-.227 1.059l-.638.637a8.036 8.036 0 0 0 3.017 3.011l.638-.637a1.006 1.006 0 0 1 1.061-.226c.456.17.93.288 1.413.351A1.006 1.006 0 0 1 15 12.487z"
      fill="#fff"
    />
  </>
);

export const svgLocation = (
  <>
    <rect x="1" y="1" width="18" height="18" rx="4" fill="#CCE1FF" />
    <path fill="#7A8994" d="M9 8h2v8H9z" />
    <circle cx="10.1" cy="7" r="3.5" fill="#FF2E57" />
  </>
);

export const svgLinkedin = (
  <>
    <rect x="1" y="1" width="18" height="18" rx="4" fill="#2867B2" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 6.5A1.25 1.25 0 1 0 6 4a1.25 1.25 0 0 0 0 2.5zm-1 .75v7.334h2V7.25H5zm8 7.334h2v-4.506c0-3.502-3.736-3.375-4.667-1.651V7.25h-2v7.334h2v-3.736c0-2.076 2.667-2.246 2.667 0v3.736z"
      fill="#fff"
    />
  </>
);

export const svgGoogleMeet = (
  <>
    <rect x="1" y="1" width="18" height="18" rx="4" fill="#F0F3F5" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m10.92 10 1.365 1.557 1.835 1.171.32-2.718-.32-2.657-1.87 1.028L10.92 10z"
      fill="#00832D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 12.476v2.316c0 .53.43.958.96.958h2.32L6.76 14l-.48-1.524-1.592-.48-1.688.48z"
      fill="#0066DA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.28 4.25 3 7.524l1.688.48 1.592-.48.472-1.503L6.28 4.25z"
      fill="#E94235"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 12.476h3.28V7.524H3v4.952z"
      fill="#2684FC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.215 5.636 14.12 7.353v5.375l2.104 1.723a.48.48 0 0 0 .776-.378V6.007a.48.48 0 0 0-.785-.37z"
      fill="#00AC47"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.92 10v2.476H6.28v3.274h6.88c.53 0 .96-.429.96-.958v-2.064L10.92 10z"
      fill="#00AC47"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.16 4.25H6.28v3.274h4.64V10l3.2-2.647V5.208c0-.53-.43-.958-.96-.958z"
      fill="#FFBA00"
    />
  </>
);

export const svgGoogle = (
  <>
    <path
      d="M10.078 5.039c1.28-.08 2.479.4 3.438 1.28l2.08-2.16C14.076 2.72 12.076 2 10.078 2 7.038 2 4.319 3.6 2.88 6.238l2.399 1.92c.8-2 2.72-3.2 4.799-3.12z"
      fill="#E94435"
    />
    <path
      d="M5.039 9.997c0-.64.08-1.28.32-1.84l-2.4-1.919C2.32 7.358 2 8.718 2 9.997c0 1.28.32 2.639.88 3.759l2.479-1.92c-.24-.56-.32-1.2-.32-1.839z"
      fill="#F8BB15"
    />
    <path
      d="M13.037 14.235c-.96.48-2 .8-3.04.72-2.079 0-3.918-1.2-4.638-3.119l-2.48 1.92c1.44 2.639 4.16 4.318 7.119 4.238 1.999.08 3.918-.64 5.438-1.84l-2.4-1.919z"
      fill="#34A751"
    />
    <path
      d="M17.995 9.997c0-.56-.08-1.04-.16-1.6H9.997v3.2h4.879v.16a4.004 4.004 0 0 1-1.76 2.478l2.4 1.92c1.68-1.6 2.559-3.839 2.479-6.158z"
      fill="#547DBE"
    />
  </>
);

export const svgGithub = (
  <>
    <rect x="1" y="1" width="18" height="18" rx="4" fill="#000" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 3c-1.663 0-3.27.607-4.537 1.712A7.224 7.224 0 0 0 3.09 9.029a7.33 7.33 0 0 0 .921 4.865 7.036 7.036 0 0 0 3.776 3.094c.35.066.478-.156.478-.346 0-.17-.006-.622-.01-1.221-1.946.434-2.357-.962-2.357-.962a1.896 1.896 0 0 0-.777-1.05c-.636-.445.048-.436.048-.436.221.031.433.114.62.242.185.129.34.299.452.497.095.178.223.334.377.46a1.476 1.476 0 0 0 1.103.323c.196-.024.385-.087.557-.186a1.55 1.55 0 0 1 .444-.96c-1.554-.18-3.188-.797-3.188-3.547a2.814 2.814 0 0 1 .72-1.926 2.642 2.642 0 0 1 .069-1.9s.588-.192 1.925.736a6.477 6.477 0 0 1 3.505 0c1.336-.928 1.923-.735 1.923-.735.258.6.283 1.28.07 1.9a2.81 2.81 0 0 1 .72 1.925c0 2.757-1.637 3.364-3.197 3.542.167.174.296.382.378.612.082.229.115.473.097.717 0 .96-.008 1.733-.008 1.969 0 .192.126.415.481.345a7.036 7.036 0 0 0 3.774-3.096 7.331 7.331 0 0 0 .918-4.864 7.225 7.225 0 0 0-2.374-4.316A6.899 6.899 0 0 0 10 3z"
      fill="#fff"
    />
  </>
);

export const svgCalendly = (
  <>
    <rect x="1" y="1" width="18" height="18" rx="4" fill="#00A2FF" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 3a.5.5 0 0 0-.5.5V4H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1v-.5a.5.5 0 0 0-1 0V4H8v-.5a.5.5 0 0 0-.5-.5zM6 5h1v.5a.5.5 0 0 0 1 0V5h4v.5a.5.5 0 0 0 1 0V5h1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm1.967 5A2 2 0 0 1 11.7 9a.5.5 0 0 0 .865-.5A2.999 2.999 0 0 0 6.967 10a3 3 0 0 0 5.598 1.5.5.5 0 0 0-.865-.5 1.999 1.999 0 0 1-3.733-1z"
      fill="#fff"
    />
  </>
);

export const svgDiscord = (
  <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="71"
      height="55"
      viewBox="0 0 71 55"
    >
      <g clipPath="url(#clip0)">
        <path d="M60.1045 4.8978C55.5792 2.8214 50.7265 1.2916 45.6527 0.41542C45.5603 0.39851 45.468 0.440769 45.4204 0.525289C44.7963 1.6353 44.105 3.0834 43.6209 4.2216C38.1637 3.4046 32.7345 3.4046 27.3892 4.2216C26.905 3.0581 26.1886 1.6353 25.5617 0.525289C25.5141 0.443589 25.4218 0.40133 25.3294 0.41542C20.2584 1.2888 15.4057 2.8186 10.8776 4.8978C10.8384 4.9147 10.8048 4.9429 10.7825 4.9795C1.57795 18.7309 -0.943561 32.1443 0.293408 45.3914C0.299005 45.4562 0.335386 45.5182 0.385761 45.5576C6.45866 50.0174 12.3413 52.7249 18.1147 54.5195C18.2071 54.5477 18.305 54.5139 18.3638 54.4378C19.7295 52.5728 20.9469 50.6063 21.9907 48.5383C22.0523 48.4172 21.9935 48.2735 21.8676 48.2256C19.9366 47.4931 18.0979 46.6 16.3292 45.5858C16.1893 45.5041 16.1781 45.304 16.3068 45.2082C16.679 44.9293 17.0513 44.6391 17.4067 44.3461C17.471 44.2926 17.5606 44.2813 17.6362 44.3151C29.2558 49.6202 41.8354 49.6202 53.3179 44.3151C53.3935 44.2785 53.4831 44.2898 53.5502 44.3433C53.9057 44.6363 54.2779 44.9293 54.6529 45.2082C54.7816 45.304 54.7732 45.5041 54.6333 45.5858C52.8646 46.6197 51.0259 47.4931 49.0921 48.2228C48.9662 48.2707 48.9102 48.4172 48.9718 48.5383C50.038 50.6034 51.2554 52.5699 52.5959 54.435C52.6519 54.5139 52.7526 54.5477 52.845 54.5195C58.6464 52.7249 64.529 50.0174 70.6019 45.5576C70.6551 45.5182 70.6887 45.459 70.6943 45.3942C72.1747 30.0791 68.2147 16.7757 60.1968 4.9823C60.1772 4.9429 60.1437 4.9147 60.1045 4.8978ZM23.7259 37.3253C20.2276 37.3253 17.3451 34.1136 17.3451 30.1693C17.3451 26.225 20.1717 23.0133 23.7259 23.0133C27.308 23.0133 30.1626 26.2532 30.1066 30.1693C30.1066 34.1136 27.28 37.3253 23.7259 37.3253ZM47.3178 37.3253C43.8196 37.3253 40.9371 34.1136 40.9371 30.1693C40.9371 26.225 43.7636 23.0133 47.3178 23.0133C50.9 23.0133 53.7545 26.2532 53.6986 30.1693C53.6986 34.1136 50.9 37.3253 47.3178 37.3253Z" />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="71" height="55" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </>
);

export const svgInstagram = (
  <>
    <path
      d="M10.002 4.871a5.118 5.118 0 00-5.126 5.127 5.118 5.118 0 005.126 5.126 5.118 5.118 0 005.127-5.126 5.118 5.118 0 00-5.127-5.127zm0 8.46A3.339 3.339 0 016.67 9.998a3.336 3.336 0 013.333-3.333 3.336 3.336 0 013.333 3.333c0 1.838-1.499 3.333-3.333 3.333zm6.532-8.67c0 .665-.535 1.196-1.195 1.196a1.196 1.196 0 111.196-1.196zm3.396 1.214c-.076-1.602-.442-3.02-1.615-4.19C17.145.516 15.727.151 14.125.07c-1.65-.093-6.6-.093-8.25 0-1.597.076-3.016.442-4.19 1.611C.512 2.85.151 4.269.07 5.871c-.093 1.65-.093 6.599 0 8.25.076 1.601.442 3.02 1.615 4.19 1.174 1.168 2.588 1.534 4.19 1.614 1.65.094 6.6.094 8.25 0 1.602-.076 3.02-.442 4.19-1.615 1.168-1.169 1.534-2.588 1.615-4.19.093-1.65.093-6.594 0-8.245zm-2.133 10.017a3.375 3.375 0 01-1.9 1.9c-1.317.523-4.44.402-5.895.402-1.454 0-4.582.116-5.894-.401a3.374 3.374 0 01-1.9-1.901c-.523-1.316-.402-4.44-.402-5.894 0-1.455-.116-4.582.401-5.894a3.374 3.374 0 011.901-1.901c1.316-.522 4.44-.402 5.894-.402 1.455 0 4.582-.116 5.894.402a3.374 3.374 0 011.901 1.9c.522 1.317.401 4.44.401 5.895 0 1.454.121 4.582-.401 5.894z"
      fill="currentColor"
    />
  </>
);

export const svgDrag = (
  <>
    <circle cx="1.83334" cy="1.83334" r="1.83334" fill="currentColor" />
    <circle cx="9.16732" cy="1.83334" r="1.83334" fill="currentColor" />
    <circle cx="1.83334" cy="9.16635" r="1.83334" fill="currentColor" />
    <circle cx="9.16732" cy="9.16635" r="1.83334" fill="currentColor" />
    <circle cx="1.83334" cy="16.4994" r="1.83334" fill="currentColor" />
    <circle cx="9.16732" cy="16.4994" r="1.83334" fill="currentColor" />
    <circle cx="1.83334" cy="23.8324" r="1.83334" fill="currentColor" />
    <circle cx="9.16732" cy="23.8324" r="1.83334" fill="currentColor" />
  </>
);

export const svgCheckmark = (
  <>
    <path
      d="M18.3147 14.5034V5.25285L10.0948 0.625L1.875 5.25285V14.5034L10.0948 19.1312L18.3147 14.5034V14.5034Z"
      fill="#1E64F5"
    />
    <path
      d="M5.95485 9.73206L8.88873 12.5098L14.2882 7.22217"
      stroke="white"
      strokeWidth="1.5"
    />
  </>
);

export const svgGreenCheckmark = (
  <>
    <path
      d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z"
      fill="#00FFC8"
    />
    <path
      d="M5.14577 10.3452L6.9061 12.0119L8.66642 13.6786L15.1458 7.33337"
      stroke="#05131D"
      strokeWidth="1.5"
    />
  </>
);

export const svgUnverified = (
  <>
    <path
      d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z"
      fill="#51687D"
    />
    <path d="M4.66675 10H15.3334" stroke="white" strokeWidth="2" />
  </>
);

export const svgWarning = (
  <>
    <svg
      width="82"
      height="100"
      viewBox="0 0 82 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M97.1164 69.5044V30.4956L69.5044 2.8836H30.4956L2.88359 30.4956V69.5044L30.4956 97.1164H69.5044L97.1164 69.5044Z"
        stroke="currentColor"
        strokeWidth="5.7672"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.2642 25.9258V58.73"
        stroke="currentColor"
        strokeWidth="5.7672"
      />
      <circle
        r="2.30688"
        transform="matrix(-1 0 0 1 50.2643 70.8998)"
        stroke="currentColor"
        strokeWidth="3.85185"
      />
    </svg>
  </>
);

export const blueTick = (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="13" cy="13" r="12.5" stroke="#1E64F5" />
    <path d="M7.12891 14.0806L10.3212 17.273L19.1849 8.38672" stroke="#6999FC" strokeWidth="2"
      strokeMiterlimit="10" />
  </svg>);
